<template>
    <CardBase title="Actividad en tiempo real" :loading="loading">
        <ul class="list-group list-group-flush m-1 m-md-3" style="max-height: 400px; overflow-y: auto; overflow-x: hidden;">
            <li
                class="list-group-item pb-0"
                v-for="(item, index) in actividades"
                :key="index"
                :class="{'pt-1': index === 0}"
            >
                <b-row class="align-items-start justify-content-between bg">
                    <b-col cols="12" md="9" class="pl-md-2">
                        <div class="d-flex">
                            <div class="mr-3 mt-1">
                                <i class="fa fa-user-circle fa-2x text-primary"></i>
                            </div>
                            <div>
                                <strong>{{ item.subscriptor.name ? item.subscriptor.name + ' - ' : '' }} {{ item.subscriptor.email }} </strong>
                                <div>
                                    <MensajeActividad :actividad="item" :boletin="boletin" />
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col cols="12" md="3" class="pl-md-0 mt-2 mt-md-0 pr-md-2 text-right">
                        <small class="text-muted">{{ item.created_at }}</small>
                    </b-col>
                </b-row>
            </li>
        </ul>

        <div v-if="actividades.length === 0 && !loading" class="text-center py-4">
            <p class="text-muted">No hay actividad reciente para mostrar</p>
        </div>
    </CardBase>
</template>

<script>
    import CardBase from './common/CardBase';
    import MensajeActividad from './MensajeActividad';

    export default {
        name: 'ActividadReciente',
        props: {
            datosActividad: {
                type: Array,
                default: () => []
            },
            boletin: {
                type: Object,
                default: () => ({})
            },
            loading: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                actividades: []
            }
        },
        watch: {
            datosActividad: {
                handler(newVal){
                    this.actividades = newVal;
                },
                deep:true,
                immediate: true
            }
        },
        components: {
            CardBase, MensajeActividad
        }
    }
</script>

<style scoped>
    .bg {
        background-color: #f6f7fa;
        padding: 10px;
    }
</style>